import { gsap } from 'gsap';
interface SoundObject {
    [key: string]: HTMLAudioElement;
}

interface TimelineObject {
    name: string;
    startTime: number;
    volume: number;
}

export default class SoundController {
    sounds: SoundObject;
    timeOuts: Array<NodeJS.Timeout>;
    timeline: Array<TimelineObject>;

    constructor(timeline, url) {
        this.sounds = {};
        this.timeline = timeline;
        this.timeOuts = [];

        this.initTimeline(url);
    }

    initTimeline(url) {
        this.timeline.forEach((sound) => {
            this.sounds[sound.name] = this.createSoundElement(sound, url);
        });
    }

    playTimeline() {
        this.timeline.forEach((element) => {
            const timeout = setTimeout(() => {
                this.play(element.name);
            }, element.startTime);
            this.timeOuts.push(timeout);
        });
    }

    killTimeline() {
        this.timeOuts.forEach((timeout) => {
            clearTimeout(timeout);
        });
        for (const name in this.sounds) {
            this.pauseAndDelete(this.sounds[name]);
        }
    }

    createSoundElement(sound, url) {
        const audio = document.createElement('audio');
        audio.src = `${url}${sound.name}.mp3`;
        audio.volume = sound.volume || 1.0;

        return audio;
    }

    play(name) {
        this.sounds[name].currentTime = 0;
        this.sounds[name].play();
    }

    async fadeOutSound(sound) {
        await gsap.to(sound, {
            volume: 0,
            duration: 0.8,
            ease: 'power1.out',
        });
    }

    async pauseAndDelete(sound) {
        if (!sound.paused) {
            await this.fadeOutSound(sound);
        }
        this.removeSound(sound);
    }

    removeSound(sound) {
        sound.removeAttribute('src');
    }
}
